import { LangKey, LangData, LangKeyLike, LangDic, GroupedLangData } from "./types";
import { allGroupedStrings, allStrings, languageNames } from "./dataLoader";
import EN from "./data/EN";
import ES from "./data/ES";
import { LangDataOption } from "@/domain";

export * from "./types";

function detectAppLanguage(): LangKey {
  try {
    let lang = "";
    if (typeof navigator !== "undefined") {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      lang = navigator.language || ((navigator as any).userLanguage as string);
      if (!lang && navigator.languages && navigator.languages.length > 0) {
        lang = navigator.languages[0];
      }
    }
    if (!lang) lang = "en-US";
    const parts = lang.split("-");
    if (parts.length === 0) return "EN";
    else return parts[0].toUpperCase() as LangKey;
  } catch (err) {
    console.error("Error detecting language", err);
    return "EN";
  }
}

export const defaultLangKey: LangKey = detectAppLanguage();

export function toLangKey(langKey?: LangKeyLike): LangKey {
  if (!langKey) return defaultLangKey;
  return langKey as LangKey;
}

function fillStrings(langs: LangDic, langKey?: LangKeyLike, defaultKey?: LangKeyLike): LangData {
  const data = langs[toLangKey(langKey)];
  const defaultData = langs[toLangKey(defaultKey)];
  if (!data) return defaultData || {};
  return {
    ...defaultData,
    ...data
  };
}

export function getLanguageNames() {
  return languageNames;
}

export function getLanguages(): LangKey[] {
  return getLanguageNames().map((l) => l.key);
}

export function getStrings(langKey?: LangKeyLike, keepEmpty = false): LangData {
  if (!keepEmpty) {
    return fillStrings(allStrings, langKey);
  } else {
    return allStrings[toLangKey(langKey)] || {};
  }
}

export function getGroupedStrings(langKey?: LangKeyLike): GroupedLangData {
  const key = toLangKey(langKey);
  return allGroupedStrings[key] || allGroupedStrings[defaultLangKey] || {};
}

export function getLangData(key: "ES" | "EN"): LangDataOption {
  if (key === "ES") {
    return {
      key,
      name: "Español", //lang.getStrings(initialLang),
      data: ES
    };
  } else {
    return {
      key,
      name: "English", //lang.getStrings(initialLang),
      data: EN
    };
  }
}
